import { useSyncExternalStore } from 'react'
import { Navigate, Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import OrderDashboard from './components/OrderDashboard'
import Products from './components/Products'
import ProductDetail from './components/ProductDetail'
import Login from './components/Login'
import Settings from './components/Settings'
import SalesReport from './components/SalesReport'
import OrderTracking from './components/OrderTracking'
import Inventory from './components/Inventory'
import CustomEmail from './pages/CustomEmail'
import { isAuthenticated, subscribeAuth } from './api/auth'
import './App.css'

function useAuthFlag() {
  return useSyncExternalStore(subscribeAuth, isAuthenticated, () => false)
}

function ProtectedRoute({ children }) {
  const location = useLocation()
  const authed = useAuthFlag()
  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return children
}

function App() {
  const authed = useAuthFlag()

  return (
    <div className="App">
      {authed ? <Navbar /> : null}
      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ProtectedRoute><OrderDashboard /></ProtectedRoute>} />
          <Route path="/tracking" element={<ProtectedRoute><OrderTracking /></ProtectedRoute>} />
          <Route path="/sales" element={<ProtectedRoute><SalesReport /></ProtectedRoute>} />
          <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/products/:id" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/custom-email" element={<ProtectedRoute><CustomEmail /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to={authed ? '/dashboard' : '/login'} replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default App
